export function ScoreBar({
  label,
  value,
  max = 10,
  color = "from-blue to-blue-glow",
}: {
  label: string;
  value: number;
  max?: number;
  color?: string;
}) {
  return (
    <div className="mb-2.5">
      <div className="flex justify-between mb-1">
        <span className="text-muted-foreground text-xs">{label}</span>
        <span className="text-foreground text-xs font-semibold">
          {value}/{max}
        </span>
      </div>
      <div className="bg-navy-mid rounded h-1.5 overflow-hidden">
        <div
          className={`h-full rounded bg-gradient-to-r ${color} transition-all duration-1000`}
          style={{ width: `${(value / max) * 100}%` }}
        />
      </div>
    </div>
  );
}
